import { axios, addHeader } from '@/api/index.js'

const progressivePurchasing = {
  async getAvailableRegionYearQuarter(payload, accessToken) {
    return await axios.get(
      '/nominationConfig/availableRegionYearQuarter?customerGroupId=' + payload,
      addHeader(accessToken, 40000)
    )
  },
  async getSummaryAndNominations(payload, accessToken) {
    return await axios.post('/nominationConfig/getSummaryAndNominations', payload, addHeader(accessToken, 20000))
  },
  async getCompletedNominations(payload, accessToken) {
    return await axios.post('/nomination/nominations', payload, addHeader(accessToken))
  },
  async getCompletedNominationHistory(id, params) {
    return await axios.get(`/progressivePurchasing/history/${id}`, { params })
  },
  async getPendingNominations(payload, accessToken) {
    return await axios.post('/nomination/nominations', payload, addHeader(accessToken, 15000))
  },
  getNominationPastRecords(payload, accessToken) {
    return axios.get('/nomination/nominationPastRecords?nominationId=' + payload, addHeader(accessToken))
  },
  updateNomination: (payload, accessToken) => {
    return axios.post('/nomination/updateNomination', payload, addHeader(accessToken))
  },
  async getMarketNominations(payload, accessToken) {
    return await axios.get(
      '/customer/asxEnergyMarketData?region=' + payload.state + '&periodType=' + payload.period,
      addHeader(accessToken, 20000)
    )
  },
  async getRemainingVolume(payload, accessToken) {
    return await axios.post('/nominationConfig/availableVolume', payload, addHeader(accessToken, 20000))
  },
  validateCustomerNomination: (payload, accessToken) => {
    return axios.post('/nomination/validateNomination', payload, addHeader(accessToken))
  },
  saveCustomerNomination: (payload, accessToken) => {
    return axios.post('/nomination/updateNomination', payload, addHeader(accessToken))
  },
}

export default progressivePurchasing
